import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Space, Spin, Flex, Layout, Col, Row, Typography } from 'antd';
import { useOrderPay } from './../controller/OrderPayController'
const { Header, Footer, Sider, Content } = Layout;

const LinePayConfirm = () => {
    // const [transactionId, setTransactionId] = useState("");
    // const [orderId, setOrderId] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const transactionId = searchParams.get('transactionId');
    const orderId = searchParams.get('orderId');
    useEffect(() => {
        getOrderPay({
            transactionId,
            orderId
        })
    }, [])

    const onFinish = ({ }) => {

    }
    const {
        OrderPayData,
        getOrderPay
    } = useOrderPay({
        onFinish
    })

    return (
        <>
            <Layout className="layout">
                <Header>
                    <div className="logo" />
                </Header>
                <Content
                    style={{
                        padding: '0 50px',
                        textAlign: 'center',
                    }}
                >
                    <div className="LinePayConfirm">
                        {OrderPayData?.[0]?.paid !== 1  ?
                            <Spin style={{ height: '50%' }} tip="LinePay 付款驗證中請稍候" fullscreen>
                            </Spin>
                            :
                            <Typography.Text>LinePay 付款已完成</Typography.Text>
                        }
                    </div>
                </Content>
                <Footer
                    style={{
                        textAlign: 'center',
                    }}
                >
                    Payment System ©2024 Created by Orange Technic
                </Footer>
            </Layout>
        </>
    );
};
export default LinePayConfirm;